var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEbike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.6459 52.1108C66.8121 48.7549 61.7917 46.7212 56.2963 46.7212C44.2585 46.7212 34.5 56.4797 34.5 68.5178C34.5 80.5553 44.2585 90.3143 56.2963 90.3143C66.2107 90.3143 74.5791 83.694 77.2228 74.634M75.4811 58.1635C76.9181 60.8205 77.8192 63.81 78.0397 66.9863",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.462 51.8038C105.691 55.802 102.657 61.8053 102.657 68.5178C102.657 80.5553 112.415 90.3143 124.453 90.3143C136.491 90.3143 146.25 80.5553 146.25 68.5178C146.25 56.4797 136.491 46.7212 124.453 46.7212C122.238 46.7212 120.099 47.0518 118.084 47.6663",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.439 72.3825C72.173 71.8448 58.9211 71.0183 56.1237 70.7108C53.5796 70.4303 53.1254 69.522 54.7975 68.289L76.4785 51.6819L70.1933 33.23H72.2691L77.1704 46.9536C83.767 46.9075 88.7606 45.2814 91.2975 43.8975L108.308 33.6913L125.261 68.5193C126.241 70.422 124.145 71.2868 123.3 69.7305C122.424 68.1158 113.402 49.4908 109 40.3801C107.309 40.6877 103.545 42.0985 102.023 45.2814C100.501 48.4644 94.6613 59.524 91.932 64.656C92.0505 65.706 92.0933 67.383 91.8525 69.096",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7558 69.2108C87.956 67.6365 86.3215 66.558 84.435 66.558C81.76 66.558 79.5914 68.727 79.5914 71.4015C79.5914 74.0768 81.76 76.245 84.435 76.245C86.0126 76.245 87.414 75.4913 88.2984 74.3235",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.593 70.9688H83.0806V72.6406H95.593V70.9688Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4969 69.9607C72.7306 69.672 60.6331 69.1072 58.3728 69.153C56.1123 69.1995 57.0723 68.7157 57.6682 68.1585L77.2017 53.6221L81.0917 66.3277",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1096 49.5334L82.821 64.713C83.1862 64.7708 84.1242 64.5398 84.9545 63.156C85.7849 61.7723 90.2362 53.5524 93.1005 48.1706C93.4687 47.4785 96.5332 43.5824 98.5515 42.2651C98.5515 42.2651 89.9304 48.6685 78.1096 49.5334Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.406 39.8027C100.361 42.4783 99.0622 44.4158 98.793 45.05L91.0665 61.1378C90.5857 62.406 89.0021 65.082 86.511 65.6355",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4466 31.7301L67.656 33.1717C68.5787 33.5176 68.9822 32.2423 70.1355 31.9031C72.269 31.2756 75.0752 31.192 76.0171 31.3841L76.0466 31.3901C77.0084 31.5865 79.3805 32.0707 79.4768 31.5571C79.6152 30.8191 78.8425 30.0458 77.6316 30.0579C73.7682 30.0963 65.3841 30.1501 62.7547 30.0579C60.1253 29.9656 62.1204 31.1342 63.4466 31.7301Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.007 30.375H98.7653V32.5081H113.007V30.375Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbike);
export default __webpack_public_path__ + "static/media/ebike.6815eba43c711ee02411a074c7164a29.svg";
export { ForwardRef as ReactComponent };